import { ActionButton, OfficeHeader, TableComponent, TableLoader } from "components";
import { useAppLocation, useAppNavigate, useAppSearch } from "_graphql/cache/auth";

import { Action } from "components/buttons/action-button";
import { FC } from "react";
import RemoveClaimContainer from "./remove";
import UpdateContainer from "./update";
import ViewClaimContainer from "./view";
import moment from "moment";
import { useKEKOfferClaims } from "hooks/data/use-offer-claims";
import { useUrlState } from "utils";

type Props = {};

const ViewClaimsPage: FC<Props> = (props) => {
  const [modal, setModal] = useUrlState("modal");
  const navigate = useAppNavigate();
  const searchParams = useAppSearch();
  const { params } = useAppLocation();
  const { claims, loading, refetch } = useKEKOfferClaims({
    args: {
      offer_id: params.offer || "",

    }
  })


  const dispatchAction =
    (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
      () => {
        navigate({
          search: (old) => ({
            ...old,
            id,
            modal: action,
          }),
        });
      };

  const expandItem = (id: string) => () => {
    navigate({
      to: `./${id}/view`,
    });
  };


  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <OfficeHeader />
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          <TableComponent
            title={""}
            loading={loading}
            columns={[
              {
                name: "Claim Amount (100%)",
                accessor: "claim_amount",
                render: (value) => <span>{value?.claim_amount} {value?.offer?.offer_detail?.currency}</span>,
              },
              {
                name: "Claim Date",
                accessor: "claim_date",
                render: (value) => <span>{moment(value?.claim_date).format("DD/MM/YYYY")}</span>,
              },
              {
                name: "Created at",
                accessor: "created_at",
                render: (value) => <span>{"N/A"}</span>,
              },
              {
                name: "Actions",
                accessor: "actions",
                render: (value) => (
                  <>
                    <ActionButton action="view" onClick={expandItem(value?.offer_claim_id)} tooltip="View Claim's Share" />
                    <ActionButton action="update" onClick={() => {
                      navigate({
                        search: (old) => ({
                          ...old,
                          id: value.offer_claim_id,
                          offer_id: params.offer || "",
                          amount: value.claim_amount?.toString() || "",
                          from: value.claim_date?.toString() || "",
                          modal: "update",
                        }),
                      });
                    }} tooltip="Modify Claim" />
                    <ActionButton action="remove" onClick={dispatchAction(value?.offer_claim_id, "remove")} tooltip="Delete Claim" />
                  </>
                )
              },
            ]}
            data={claims}
            refetch={refetch}
            renderLoader={() => <TableLoader items={[1, 1, 1, 1]} />}
          />
        </div>
      </div>
      {searchParams.id && (
        <>
          <UpdateContainer
            open={modal === "update"}
            setOpen={(val: boolean) => {
              setModal(val ? "update" : undefined)
              navigate({
                search: (old) => ({
                  ...old,
                  id: undefined,
                  offer_id: undefined,
                  amount: undefined,
                  from: undefined,
                  modal: undefined,
                }),
              })
            }}
            refetch={refetch}
          />
          <ViewClaimContainer
            open={modal === "view"}
            setOpen={(val: boolean) => {
              setModal(val ? "view" : undefined)
              navigate({
                search: (old) => ({
                  ...old,
                  id: undefined,
                  modal: undefined,
                }),
              })
            }}
            refetch={refetch}
          />
          <RemoveClaimContainer
            open={modal === "remove"}
            setOpen={(val: boolean) => {
              setModal(val ? "remove" : undefined)
              navigate({
                search: (old) => ({
                  ...old,
                  id: undefined,
                  modal: undefined,
                }),
              })
            }}
            refetch={refetch}
          />
        </>
      )}
    </main>
  );
};

export default ViewClaimsPage;
